import Vue from 'vue'
import Router from 'vue-router'
import Auth from './guards/Auth'
import AlreadyLogin from './guards/AlreadyLogin'

Vue.use(Router)

export default new Router({
  // base: '/',
  // mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('./layouts/Web'),
      children: [
        {name: 'Libreria', path: '', component: () => import('./views/web/Web')},
        {name: 'Libros', path: 'catalogo', component: () => import('./views/web/Libros')},
        {name: 'Cotizar', path: 'cotizacion', component: () => import('./views/web/Cotizar')},
        {name: 'Contacto', path: 'contacto', component: () => import('./views/web/Contacto')},
        {name: 'Gracias', path: 'gracias', component: () => import('./views/web/Gracias')},
        {name: 'Promocion', path: 'promocion/:id', component: () => import('./views/web/Promocion')},
        {name: 'Recibido', path: 'recibido', component: () => import('./views/web/Recibido')}
      ]
    },
    {
      path: '/acceso/',
      component: () => import('./layouts/Blank'),
      children: [
        {name: 'Acceso', path: '', component: () => import('./views/Login'), beforeEnter: AlreadyLogin}
      ]
    },
    {
      path: '/app/',
      component: () => import('./layouts/App'),
      children: [
        {name: 'Administración', path: '', component: () => import('./views/app/Home'), beforeEnter: Auth},
        {name: 'Contenidos', path: 'contenidos', component: () => import('./views/app/Contenidos'), beforeEnter: Auth},
        {name: 'Cotizaciones', path: 'cotizaciones', component: () => import('./views/app/Cotizaciones'), beforeEnter: Auth},
        {name: 'Ventas', path: 'ventas', component: () => import('./views/app/Venta'), beforeEnter: Auth},
        {name: 'Reservas', path: 'reservas', component: () => import('./views/app/Reservas'), beforeEnter: Auth},
        {name: 'Añadir Libro', path: 'anadir', component: () => import('./views/app/AnadirLibro'), beforeEnter: Auth},
        {name: 'Catálogo', path: 'catalogo', component: () => import('./views/app/Catalogo'), beforeEnter: Auth},
        {name: 'Colecciones', path: 'colecciones', component: () => import('./views/app/Colecciones'), beforeEnter: Auth},
        {name: 'Estadisticas', path: 'estadisticas', component: () => import('./views/app/Estadisticas'), beforeEnter: Auth},
        {name: 'Clientes', path: 'clientes', component: () => import('./views/app/Clientes'), beforeEnter: Auth},
        {name: 'Novedades', path: 'novedades', component: () => import('./views/app/Novedades'), beforeEnter: Auth}
      ]
    },
    {
      path: '*',
      component: () => import('./layouts/Blank'),
      children: [
        {name: '404', path: '', component: () => import('./views/404.vue'), meta: {titulo: '404'}}
      ]
    }
  ]
})
